// @flow

import * as React from 'react';
import url from 'url';
import path from 'path';

import { compose } from 'redux';
// $FlowFixMe[missing-export]
import { connect, type Connector } from 'react-redux';

import { selectFromConfig } from '@gandi/redux-config';
import { localeSelector, withTranslator } from '@gandi/translate';

import { withRouter } from 'src/helpers/withRouter';
import type { FullState } from 'src/types';
import { selectNavigationUrls } from 'src/containers/modules';
import Success, { type DecoratedProps, type StateProps } from './Success';

const selectLayoutUrls = selectFromConfig<{ [string]: string }>(
  'app.layout.urls',
  {}
);

const mapStateToProps = (
  state: FullState,
  ownProps: DecoratedProps
): StateProps => {
  const navigationUrls = selectNavigationUrls(state, ownProps);
  const adminUrl = selectFromConfig<string>(
    'app.layout.urls.admin',
    'https://admin.gandi.net'
  )(state);
  const documentationUrl = selectFromConfig<string>(
    'app.layout.urls.docs',
    'https://docs.gandi.net'
  )(state);
  const enhancedPublicUrls = {
    adminUrl,
    documentationUrl,
    ...navigationUrls,
  };

  const locale = localeSelector(state);
  const layoutUrls = selectLayoutUrls(state);
  let publicSite = layoutUrls.public_site || 'https://www.gandi.net';
  const corporateUrl = url.resolve(publicSite, path.join(locale, 'corporate'));
  const searchDomainUrl = url.resolve(publicSite, path.join(locale, 'domain'));
  publicSite = url.resolve(publicSite, locale);

  return {
    locale: localeSelector(state),
    publicUrls: enhancedPublicUrls,
    corporateUrl,
    publicSite,
    searchDomainUrl,
  };
};

const connector: Connector<{ ... }, Partial<StateProps>> = connect(
  mapStateToProps
);

export default (compose(
  // $FlowFixMe[underconstrained-implicit-instantiation]
  withRouter,
  withTranslator({ propsNamespace: 'translator' }),
  connector
)(Success): React.ComponentType<{||}>);
